export const transcoderOutputBucket = "r3z-video-output";
